import { StreamTimeSeriesState } from 'widgets/store/stream/WidgetStreamState';

import { MarketVolMap } from 'widgets/venueAnalysis/api/VenueAnalysisResponseData';
import {
    StreamState,
    StreamsByStreamKeyState,
} from 'streamsState/store/streamedData/StreamedDataState';

export type VenueAnalysisStreamState = StreamState<VenueAnalysisDataState>;
export type VenueAnalysisStreamsState =
    StreamsByStreamKeyState<VenueAnalysisDataState>;

export interface VenueAnalysisDataState
    extends StreamTimeSeriesState<VenueAnalysisDataTimeSeriesItem> {
    orderInfo?: VenueAnalysisOrderInfoState;
    qtyInfo?: VenueAnalysisQtyInfoState;
    fillInfo?: VenueAnalysisFillInfoState;
    mktVolHist?: VenueAnalysisMktVolHisState;
    mktVolRt?: VenueAnalysisMktVolRealTimeState;
}

export interface VenueAnalysisDataTimeSeriesItem {
    _i: number;
    id: string;
    executionId: number;
    orderId: number;
    fillQty: number;
    executionTime: number;
    executionPrice: number;
    executionBroker: string;
    lastMkt: string;
    venueName: string;
    venueType: string;
    liquidityType: string;
    buySideLiquidityCode: number;
    parentOrderSide: number;
    /*
     * IND2-2409: Liquidity code (derived from neut , bsLiq and rawLiq Fill fields using TCA algorithm)
     * This is a char value
     */
    liquidityCode: string;
}

export interface VenueAnalysisOrderInfoState {
    symbolDescription: string;
    symbol: string;
    arrivalTimeEpoch: number;
    tickSize?: number;
}
export interface VenueAnalysisQtyInfoState {
    buyOrderQty: number;
    sellOrderQty: number;
}

export interface VenueAnalysisFillInfoState {
    buyFillQty: number;
    sellFillQty: number;
    buyRemainingQty: number;
    sellRemainingQty: number;
    buyFillPrice: number;
    sellFillPrice: number;
}

export type VenueAnalysisMktVolHisState = MarketVolMap;
export type VenueAnalysisMktVolRealTimeState = MarketVolMap;

export const initialVenueAnalysisDataState: VenueAnalysisDataState = {
    timeSeries: [],
};

export const initialVenueAnalysisStreamState: VenueAnalysisStreamState = {
    data: initialVenueAnalysisDataState,
    messages: [],
};
